export function getEmpresaId() {
    return localStorage.getItem('empresaId') || null;
}
export function getPessoaId() {
    return localStorage.getItem('pessoaId') || null;
}
export function getEmpresaIds() {
    const empresaId = getEmpresaId();

    const raw = localStorage.getItem('empresaIds');
    if (!raw) return empresaId ? [empresaId] : [];

    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
        return empresaId ? [empresaId] : [];
    } catch (e) {
        console.warn('empresaIds inválido, usando empresaId:', e);
        return empresaId ? [empresaId] : [];
    }
}

/**
 * Útil quando você quer sempre garantir ambos:
 * - empresaId selecionada
 * - empresaIds permitidas
 */
export function getEmpresaScope() {
    const pessoaId = getPessoaId();
    const empresaId = getEmpresaId();
    const empresaIds = getEmpresaIds();
    return { pessoaId, empresaId, empresaIds };
}
